import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface UserState {
  isUserAuthenticated: boolean;
  userId: string;
  role: string;
  roleId: string;
  platformPermissions: any[];
  toggleLoader: boolean;
  firstName: string;
  lastName: string;
}

const initialState: UserState = {
  isUserAuthenticated: false,
  userId: "",
  role: "",
  roleId: "",
  platformPermissions: [],
  toggleLoader: false,
  firstName: "",
  lastName: "",
};

const getIntialState = (): UserState => {
  let isUserAuthenticated = false;
  let role = "";
  let userId = "";
  let firstName = "";
  let lastName = "";
  const token = localStorage.getItem("sm-access-token") ?? "";
  if (token) {
    try {
      userId = localStorage.getItem("user-id") ?? "";
      isUserAuthenticated = true;
      role = localStorage.getItem("role") ?? "";
      firstName = localStorage.getItem("first-name") ?? "";
      lastName = localStorage.getItem("last-name") ?? "";
    } catch (err) {}
  }
  return {
    ...initialState,
    firstName,
    lastName,
    isUserAuthenticated: isUserAuthenticated,
    userId: userId,
    role: role,
    platformPermissions: [],
  };
};

export const userSlice = createSlice({
  name: "user",
  initialState: getIntialState,
  reducers: {
    setUserAuth: (
      state,
      action: PayloadAction<{
        authenticated: boolean;
        role: string;
        userId: string;
      }>
    ) => {
      state.role = action.payload.role;
      state.isUserAuthenticated = action.payload.authenticated;
      state.userId = action.payload.userId;
    },
    setUserName: (
      state,
      action: PayloadAction<{
        firstName: string;
        lastName: string;
      }>
    ) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
    },

    setPlatformPermissions: (state, action: PayloadAction<any>) => {
      state.platformPermissions = action.payload;
    },
    setRoleId: (state, action: PayloadAction<string>) => {
      state.roleId = action.payload;
    },
    setStateToggle: (state) => {
      state.toggleLoader = !state.toggleLoader;
    },
    reset: () => initialState,
  },
});

export const {
  setUserAuth,
  setUserName,
  reset,
  setPlatformPermissions,
  setRoleId,
  setStateToggle,
} = userSlice.actions;

export default userSlice.reducer;
